import React from "react";
import "./flashproduct.css";
import { useNavigate } from "react-router-dom";

function FlashProduct({ flashdata }) {
  const navigate = useNavigate();
  return (
    <div className="flashproduct-container">
      {flashdata.map((data) => (
        <div
          className="flash-info"
          key={data.id}
          onClick={() => navigate(`/productinfo/${data.id}`)}
        >
          <img className="flash-image" src={data.imageurl} alt=" " />
          <div className="flash-detail">
            <div className="flash-title">
              <h3>{data.title}</h3>
            </div>
            <p className="flash-price">{data.price}</p>
            <p className="flash-discount">
              <s>{data.expectprice}</s> {data.discount}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FlashProduct;
